export const URL_COMMENT_CREATE = '/comment-projects/create';
export const URL_COMMENT_UPDATE = '/comment-projects/update/:id';
export const URL_COMMENTS_LIST = '/comment-projects/:project_id';
export const URL_COMMENT_DELETE = '/comment-projects/delete/:id';
export const URL_COMMENT_NODES_CREATE = '/comment-nodes/create';
export const URL_COMMENT_NODES_UPDATE = '/comment-nodes/update/:id';
export const URL_COMMENT_NODES_DOMAIN_TYPE = '/comment-nodes/update-type/:id';
export const URL_COMMENTS_NODES_LIST = '/comment-nodes/:node_id';
export const URL_COMMENT_NODES_DELETE = '/comment-nodes/delete/:id';
export const URL_COMMENT_NODES_COUNT = '/comment-nodes/comment-counts/:id';
export const URL_COMMENT_PROJECTS_DOMAIN_TYPE = '/comment-projects/update-type/:id';
